import React, { createRef, CSSProperties } from "react";
import {
  Modal,
  Grid,
  Button,
  TextArea,
  Form,
  Dimmer,
  Loader,
  Segment,
  Icon,
  ButtonProps,
} from "semantic-ui-react";

// const SnackMessage = React.lazy(()=> import('../../../../HIS/common/SnackMessage').catch(()=> ({default: ()=> null })))

import ErrorMessage from "react-lib/apps/common/ErrorMessage";
import { useIntl } from "react-intl";


interface Props {
  textContent?: string | number | React.ReactElement;
  content?: Record<string, any> | string | number | React.ReactElement;
  titleName?: string | number | React.ReactElement;
  size?: string;
  approveButtonText?: string;
  denyButtonText?: string;
  approveButtonColor?: string;
  approveButtonLoading?: boolean;
  approveButtonStyle?: Record<string, any>;
  approveButton?: React.ReactElement | boolean;
  approveButtonName?: string;
  denyButton?: React.ReactElement | boolean;
  denyButtonColor?: string;
  denyButtonStyle?: Record<string, any>;
  disabledApproveButton?: boolean;
  disabledDenyButton?: boolean;
  buttonClassName?: string;
  loading?: boolean;
  openModal?: boolean;
  onApprove?: ButtonProps["onClick"];
  onDeny?: () => void;
  basic?: boolean;
  modalStyle?: Record<string, any>;
  closeIcon?: boolean;
  onCloseWithDimmerClick?: () => void;
  autoFocusConfirm?: boolean;
  centered?: boolean;
  titleColor?: string;
  backgroundColor?: string;
  customGridGroup?: CSSProperties;
}

/**
 * A modal display the settings of shift on the given division.
 */
export default class ModConfirmCNMI extends React.Component<Props, any> {

  static defaultProps = {
    textContent: null,
    content: null,
    backgroundColor: null,
    titleName: "แจ้งเตือน!!!",
    size: "mini",
    approveButtonText: "ใช่",
    denyButtonText: "ไม่",
    approveButtonColor: "green",
    approveButtonLoading: false,
    approveButtonStyle: {},
    approveButton: null,
    denyButton: null,
    denyButtonColor: "red",
    denyButtonStyle: {},
    disabledApproveButton: false,
    disabledDenyButton: false,
    buttonClassName: "centered six wide",
    loading: false,
    openModal: false,
    basic: true,
    modalStyle: {},
    // loading: false,
    testId: "",
    // Handle closeOnDimmerClick event
    onCloseWithDimmerClick: () => {},
    autoFocusConfirm: false,
  };

  buttonRef: any;

  constructor(props: any) {
    super(props);

    this.buttonRef = createRef<Button>();
  }

  componentDidUpdate = (prevProps: any, prevState: any) => {
    if (this.buttonRef?.current && this.props.autoFocusConfirm) {
      this.buttonRef.current.focus();
    }
  };

  render() {
    const {
      textContent,
      content,
      titleName,
      size,
      basic,
      titleColor,
      approveButtonText,
      denyButtonText,
      approveButtonColor,
      approveButtonLoading,
      approveButtonName,
      approveButtonStyle,
      approveButton,
      denyButton,
      denyButtonColor,
      denyButtonStyle,
      disabledApproveButton,
      disabledDenyButton,
      buttonClassName,
      loading,
      openModal,
      backgroundColor,
      testId,
      className,
      modalStyle,
      // TextArea
      textNote,
      setTextNote,
      showTextNote,
      // SnackMessage
      onEvent,
      setProp,
      cardName,
      submitError,
      submitSuccess,
      // ErrorMessage,
      errorMessageText,
    } = this.props;

    let headerColor = titleColor;

    if (!titleColor && !backgroundColor) {
      headerColor = "blue";
    }

    return (
      <Modal
        open={openModal}
        size={size}
        testid={"modConfirm" + testId}
        closeOnDimmerClick={true}
        onClose={this.props.onCloseWithDimmerClick}
        className={`${className} ${this.props.centered ? "centered" : ""}`}
        style={modalStyle}
      >
        <Segment
          className={"inverted " + headerColor}
          style={{
            ...styles.header,
            backgroundColor: backgroundColor,
            ...this.props.customStyleHeader,
          }}
        >
          {titleName}
          {this.props.closeIcon && (
            <Icon name="close" link={true} onClick={this.props.onCloseWithDimmerClick} />
          )}
        </Segment>
        <Segment
          id={"modConfirm-Segment" + testId}
          basic
          loading={this.props.loading}
          style={{ ...styles.content, ...this.props.customStyleBasic }}
        >
          {textContent}
          {content}
          {this.props.oneBr ? (
            <br />
          ) : (
            <>
              {" "}
              <br /> <br />{" "}
            </>
          )}
          {showTextNote && (
            <Form style={{ marginBottom: "20px" }}>
              {" "}
              <div>
                {" "}
                <TextArea
                  id={"modConfirm-TextArea" + testId}
                  onChange={setTextNote}
                  value={textNote}
                  style={{ maxHeight: "100px", minHeight: "100px" }}
                />{" "}
              </div>{" "}
            </Form>
          )}
          {/* {submitError && SnackMessage && (
            <React.Suspense fallback={'loading...'}>
              <SnackMessage
              onEvent={onEvent}
              onClose={() => {
                setProp(`errorMessage.${cardName}`, null);
              }}
              error={submitError}
              success={submitSuccess}
            />
            </React.Suspense>
          )} */}
          {errorMessageText && <ErrorMessage error={errorMessageText} />}
          <Grid style={this.props.customGridGroup}>
            <Grid.Column
              style={{
                display: !approveButtonText ? "none" : null,
                ...this.props.customGridButton,
              }}
              className={buttonClassName}
            >
              <>
                {!approveButton ? (
                  <Button
                    id="modConfirm-Button-Approve"
                    ref={this.buttonRef}
                    basic={basic}
                    fluid
                    color={approveButtonColor}
                    onClick={this.props.onApprove}
                    loading={approveButtonLoading}
                    name={approveButtonName}
                    style={approveButtonStyle}
                    disabled={disabledApproveButton}
                  >
                    {approveButtonText}
                  </Button>
                ) : (
                  approveButton
                )}
              </>
            </Grid.Column>
            <Grid.Column
              style={{
                display: !denyButtonText ? "none" : null,
                ...this.props.customGridButton,
              }}
              className={buttonClassName}
            >
              <>
                {!denyButton ? (
                  <Button
                    id="modConfirm-Button-Deny"
                    basic={basic}
                    fluid
                    color={denyButtonColor}
                    onClick={this.props.onDeny}
                    style={denyButtonStyle}
                    disabled={disabledDenyButton}
                  >
                    {denyButtonText}
                  </Button>
                ) : (
                  denyButton
                )}
              </>
            </Grid.Column>
          </Grid>
        </Segment>
      </Modal>
    );
  }
}

const styles = {
  header: {
    borderRadius: 0,
    fontWeight: "bold",
    display: "flex",
    justifyContent: "space-between",
  },
  content: {
    lineHeight: "1.5em",
  },
};
